module.exports = __webpack_public_path__ + "static/img/china-banbg.b4373eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-banbg.jpg
// module id = 1387
// module chunks = 1